import React from "react";
import ErrorFeedbackBar from "../../global/ErrorFeedbackBar";
import { BALANCE_SHEET_PAGES } from './constants';
import FeedbackBar from "../../feedbackBar/FeedbackBar";
import withShipment from "../../../withShipment";
import {
    assetsSelector,
    balanceSheetTemplateSelector,
    ledgersForSettingsSelector,
    liabilityAndEquitySelector,
    loadingSelector,
} from '../../../redux/selectors/accounting';
import {statusSelector} from "../../../redux/selectors/global";
import {clearStatus} from "../../../redux/actions/global";
import {userInfoSelector} from "../../../redux/selectors/auth";
import {tableSettingSelector} from "../../../redux/selectors/account";
import {getTableSetting, saveTableSetting} from "../../../redux/actions/account";
import BalanceSheetTable from './BalanceSheetTable';
import BalanceSheetSettings from './BalanceSheetSettings';
import {
    listLedgersForSettings,
    listBalanceSheet,
    listBalanceSheetMappingTemplate,
    saveBalanceSheetMappingTemplate,
} from '../../../redux/actions/accounting';

class BalanceSheet extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: BALANCE_SHEET_PAGES.TABLE,
            feedbackBarOpen: false,
            error: false,
            selectedYear: new Date().getFullYear(),
            selectedCurrency: 'CAD',
            balanceSheetFilterSetting: null,
        }
    }

    componentDidMount() {
        this.props.getTableSetting(this.props.user.userId)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.status.statusText && prevProps.status.statusText !== this.props.status.statusText){
            this.openFeedbackBar()
        }

        if (prevProps.tableSetting !== this.props.tableSetting) {
            this.setState({ balanceSheetFilterSetting: this.props.tableSetting?.balanceSheetFilterSetting },()=>{
                this.setState({
                    selectedCurrency: this.state.balanceSheetFilterSetting.currency,
                    selectedYear: this.state.balanceSheetFilterSetting.year,
                },()=>{
                    this.props.listBalanceSheetMappingTemplate({year: this.state.selectedYear})
                    this.props.listLedgersForSettings({year: this.state.selectedYear})
                    this.listBalanceSheetAPI()
                })
            })
        }




    }

    handleSave = (templates) => {
        this.props.saveBalanceSheetMappingTemplate(
          templates,
          this.state.selectedYear,
          () => {
            this.listBalanceSheetAPI();
            this.setCurrentPage(BALANCE_SHEET_PAGES.TABLE, {});
          }
        );

    }

    listBalanceSheetAPI = () =>{
        const data = {
            "year": this.state.selectedYear,
            "currency": this.state.selectedCurrency,
        }
        this.props.listBalanceSheet(data)
    }



    handleYearChange = (event) => {
        this.setState({ selectedYear: event.target.value },() => {
            this.onFiltersInputChange("year",event)
        })

    }

    handleCurrencyChange = (event) => {
        this.setState({ selectedCurrency: event.target.value },() => {
            this.onFiltersInputChange("currency",event)
        })
    }


    setCurrentPage = (newPage) => {
        this.setState({
            currentPage: newPage
        })
    }

    displayTable = () => {
            return (
                <BalanceSheetTable
                    setFetch={this.setFetch}
                    loadingData={this.props.loadingData}
                    selectedYear={this.state.selectedYear}
                    handleYearChange={this.handleYearChange}
                    selectedCurrency={this.state.selectedCurrency}
                    handleCurrencyChange={this.handleCurrencyChange}
                    setCurrentPage={this.setCurrentPage}
                    openFeedbackBar={this.openFeedbackBar}
                    assetsList={this.props.assetsList}
                    liabilityAndEquityList={this.props.liabilityAndEquityList}
                />
            )
    }

    displaySettings = () => {
        return (
          <BalanceSheetSettings
            allLedgers={this.props.ledgersForSettings}
            handleSave={this.handleSave}
            templates={this.props.templates}
            setCurrentPage={this.setCurrentPage}
            openFeedbackBar={this.openFeedbackBar}
            selectedYear={this.state.selectedYear}
            />
        )
    }


    displayCurrentPage = () => {
        switch (this.state.currentPage) {
            case BALANCE_SHEET_PAGES.TABLE:
                return this.displayTable()
            case BALANCE_SHEET_PAGES.SETTINGS:
                return this.displaySettings()
            default:
                return <div>We encountered an error. Please refresh the page.</div>
        }
    }

    openFeedbackBar = () => {
        this.setState({feedbackBarOpen: true})
    }

    closeFeedbackBar = () => {
        this.setState({ feedbackBarOpen: false }, () => {
            this.props.clearStatus()
        })
    }

    onFiltersInputChange = (name,event) => {
        let filtersMap = this.props.tableSetting?.balanceSheetFilterSetting
        filtersMap[name] = event.target.value;
        this.saveUpdatedFilters(filtersMap)
    }


    saveUpdatedFilters = (filters) => {
        this.props.saveTableSetting({
            userId: this.props.user.userId,
            tableSetting: null,
            changeFilters: false,
            changeBalanceSheetFilters : true,
            balanceSheetFilters: filters
        })
    }

    render() {
        return (
            <React.Fragment>
                <ErrorFeedbackBar/>
                <FeedbackBar
                    open={this.state.feedbackBarOpen}
                    handleClose={this.closeFeedbackBar}
                    severity={this.props.status?.success ? 'success' : 'error'}
                    message={this.props.status?.statusText}
                />
                {this.displayCurrentPage()}
            </React.Fragment>
        )
    }
}


const mapStateToProps = (state) => ({
    status: statusSelector(state),
    user: userInfoSelector(state),
    loadingData: loadingSelector(state),
    tableSetting: tableSettingSelector(state),
    ledgersForSettings: ledgersForSettingsSelector(state),
    templates: balanceSheetTemplateSelector(state),
    assetsList: assetsSelector(state),
    liabilityAndEquityList: liabilityAndEquitySelector(state),
})


const actionCreators = {
    clearStatus,
    saveTableSetting,
    getTableSetting,
    listLedgersForSettings,
    listBalanceSheetMappingTemplate,
    saveBalanceSheetMappingTemplate,
    listBalanceSheet
}

export default withShipment({
    actionCreators,
    mapStateToProps
}, BalanceSheet);